import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 * @param organisationId string
 * @param reportId string
 * @param parameters Array
 *
 * @return {Promise<any>|Promise}
 */
export default (function (organisationId, reportId, parameters) {
    var url = applyPathVariables(EndPoints.REPORTS_RUN, {
        organisationId: organisationId,
        reportId: reportId,
    });
    var headers = { 'Content-Type': 'application/json' };
    var request = new Request({
        method: Methods.POST,
        url: url,
        withCredentials: true,
        data: parameters,
        headers: headers
    });
    return request.execute();
});
